export const regexModule4QuestionBank = [
  // Alternation (OR) Operator (25 questions)
  {
    id: 'q1',
    question: 'What does the | operator do in regex?',
    choices: [
      'Matches the beginning of a line',
      'Matches either the pattern before or after it (OR)',
      'Matches the end of a line',
      'Escapes special characters',
    ],
    correctAnswer: 1,
    explanation:
      'The | operator is the alternation operator, which matches either the pattern before it OR the pattern after it.',
  },
  {
    id: 'q2',
    question: 'Which pattern matches either "cat" or "dog"?',
    choices: ['cat&dog', 'cat|dog', 'cat+dog', 'cat.dog'],
    correctAnswer: 1,
    explanation: 'cat|dog uses the alternation operator | to match either "cat" or "dog".',
  },
  {
    id: 'q3',
    question: 'What does the pattern "red|blue|green" match?',
    choices: [
      'Only the exact string "red|blue|green"',
      'Any of the words: red, blue, or green',
      'All three words together',
      'Words containing red, blue, and green',
    ],
    correctAnswer: 1,
    explanation:
      'The pattern matches any one of the three alternatives: "red" OR "blue" OR "green".',
  },
  {
    id: 'q4',
    question: 'In the pattern "apple|orange juice", what gets matched?',
    choices: [
      'Either "apple" or "orange juice"',
      'Either "apple" or "orange" followed by "juice"',
      'Only "apple orange juice"',
      'The literal string "apple|orange juice"',
    ],
    correctAnswer: 0,
    explanation:
      'Without grouping, alternation has low precedence, so it matches "apple" OR "orange juice" as complete alternatives.',
  },
  {
    id: 'q5',
    question: 'How would you match either "color" or "colour" using alternation?',
    choices: ['color&colour', 'color|colour', 'color+colour', 'color?colour'],
    correctAnswer: 1,
    explanation: 'color|colour uses alternation to match either spelling variant.',
  },
  {
    id: 'q6',
    question: 'What does "jpg|jpeg|png|gif" match?',
    choices: [
      'Only files with all four extensions',
      'Any one of the four image file extensions',
      'Files containing all these extensions',
      'The literal text "jpg|jpeg|png|gif"',
    ],
    correctAnswer: 1,
    explanation: 'This pattern matches any one of the four common image file extensions.',
  },
  {
    id: 'q7',
    question: 'In "Mr|Mrs|Ms|Dr Smith", what part gets matched?',
    choices: [
      'Only "Mr Smith", "Mrs Smith", "Ms Smith", or "Dr Smith"',
      'Either "Mr", "Mrs", "Ms", or "Dr" followed by any text',
      'The titles only: "Mr", "Mrs", "Ms", or "Dr"',
      'Only complete names with Smith',
    ],
    correctAnswer: 2,
    explanation:
      'Without grouping, the alternation only applies to the titles, not to the complete phrase with Smith.',
  },
  {
    id: 'q8',
    question: 'How do you match either "http" or "https" at the start of a URL?',
    choices: ['http|https://', 'http(s)?://', 'https?://', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All three patterns work: alternation (http|https), optional group (http(s)?), or optional character (https?).',
  },
  {
    id: 'q9',
    question: 'What is the precedence of the | operator compared to other regex operators?',
    choices: [
      'Highest precedence',
      'Medium precedence',
      'Low precedence',
      'Same as all other operators',
    ],
    correctAnswer: 2,
    explanation:
      'The alternation operator | has low precedence, so other operators bind more tightly.',
  },
  {
    id: 'q10',
    question: 'Which pattern correctly matches "gray" or "grey"?',
    choices: ['gr[ay]y', 'gr(a|e)y', 'gray|grey', 'Both B and C'],
    correctAnswer: 3,
    explanation:
      'Both gr(a|e)y (grouped alternation) and gray|grey (full alternation) correctly match both spellings.',
  },
  {
    id: 'q11',
    question: 'In "cat|dog food", what does this pattern match?',
    choices: [
      'Either "cat" or "dog food"',
      'Either "cat food" or "dog food"',
      'Only "cat dog food"',
      'Either "cat" or "dog" followed by "food"',
    ],
    correctAnswer: 0,
    explanation:
      'Due to operator precedence, this matches "cat" OR "dog food", not what you might expect.',
  },
  {
    id: 'q12',
    question: 'How would you match either "email" or "e-mail"?',
    choices: ['email|e-mail', 'e-?mail', 'e(-)?mail', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All three patterns work: full alternation (email|e-mail), optional hyphen (e-?mail), or optional group (e(-)?mail).',
  },
  {
    id: 'q13',
    question: 'What does "Monday|Tuesday|Wednesday|Thursday|Friday" match?',
    choices: [
      'Only complete weekday names',
      'Any text containing these day names',
      'All five days together',
      'Abbreviations of weekdays',
    ],
    correctAnswer: 0,
    explanation: 'This pattern matches any one of the five complete weekday names.',
  },
  {
    id: 'q14',
    question: 'In "yes|no|maybe", which strings would match?',
    choices: [
      'Only "yes", "no", "maybe"',
      'Any string containing these words',
      'Only if all three appear together',
      'Partial matches like "ye" or "ma"',
    ],
    correctAnswer: 1,
    explanation:
      'The pattern matches any string containing "yes" OR "no" OR "maybe" anywhere within it.',
  },
  {
    id: 'q15',
    question: 'How do you match either ".com" or ".org" domain extensions?',
    choices: ['.com|.org', '\\.com|\\.org', '.(com|org)', 'Both B and C'],
    correctAnswer: 3,
    explanation: 'Both .com|.org and .(com|org) work correctly, escaping the literal dot.',
  },
  {
    id: 'q16',
    question: 'What happens with "a|b|c|d" when matching "abcd"?',
    choices: [
      'Matches the entire string "abcd"',
      'Matches only the first character "a"',
      'Matches all four characters separately',
      'No match occurs',
    ],
    correctAnswer: 1,
    explanation:
      'Alternation finds the first match, which is "a", and stops there unless using findall().',
  },
  {
    id: 'q17',
    question: 'Which is more efficient for matching "color" or "colour"?',
    choices: ['color|colour', 'colou?r', 'Both are equally efficient', 'col(or|our)'],
    correctAnswer: 1,
    explanation:
      'colou?r is more efficient as it shares the common prefix and only makes the "u" optional.',
  },
  {
    id: 'q18',
    question: 'In "apple|orange|banana", what type of matching occurs?',
    choices: ['Greedy matching', 'Lazy matching', 'Leftmost matching', 'Rightmost matching'],
    correctAnswer: 2,
    explanation:
      'Alternation uses leftmost matching - it tries alternatives from left to right and uses the first match found.',
  },
  {
    id: 'q19',
    question: 'How do you match either "Mr." or "Mrs." (including the period)?',
    // eslint-disable-next-line no-useless-escape
    choices: ['Mr|Mrs.', 'Mr.|Mrs.', 'Mr\.|Mrs\.', 'Both B and C'],
    correctAnswer: 3,
    explanation:
      'Both Mr.|Mrs. and Mr.|Mrs. work. The period can be literal or escaped in this context.',
  },
  {
    id: 'q20',
    question: 'What does "jpg|jpeg" match in "image.jpeg"?',
    choices: ['The entire filename', 'Just "jpeg"', 'Just "jpg"', 'No match'],
    correctAnswer: 1,
    explanation:
      'The pattern matches "jpeg" in the filename, as it\'s one of the two alternatives.',
  },
  {
    id: 'q21',
    question: 'Which pattern matches either "1st", "2nd", "3rd"?',
    choices: ['1st|2nd|3rd', '[123](st|nd|rd)', '[123](st|nd|rd)', 'All of the above'],
    correctAnswer: 3,
    explanation: 'All patterns work, though the character class with alternation is more concise.',
  },
  {
    id: 'q22',
    question: 'In "cat|dog|bird", how many alternatives are there?',
    choices: ['Two', 'Three', 'Four', 'One'],
    correctAnswer: 1,
    explanation: 'There are three alternatives: "cat", "dog", and "bird".',
  },
  {
    id: 'q23',
    question: 'What does "^(cat|dog)" match?',
    choices: [
      'Lines starting with "cat" or "dog"',
      'Lines ending with "cat" or "dog"',
      'Any line containing "cat" or "dog"',
      'The literal text "^(cat|dog)"',
    ],
    correctAnswer: 0,
    explanation:
      'The ^ anchor ensures the match occurs at the start of a line, and the group contains the alternation.',
  },
  {
    id: 'q24',
    question: 'How do you match either "US" or "USA"?',
    choices: ['US|USA', 'USA?', 'US(A)?', 'Both B and C'],
    correctAnswer: 3,
    explanation:
      'Both USA? and US(A)? work correctly by making the "A" optional. US|USA would work but USA? is more efficient.',
  },
  {
    id: 'q25',
    question: 'What is the output of re.findall("a|b", "abab")?',
    choices: ['["a"]', '["a", "b", "a", "b"]', '["ab", "ab"]', '["abab"]'],
    correctAnswer: 1,
    explanation:
      'findall() returns all matches, so it finds each "a" and "b" separately: ["a", "b", "a", "b"].',
  },

  // Grouping and Precedence (25 questions)
  {
    id: 'q26',
    question: 'What do parentheses () do in regex?',
    choices: [
      'Match literal parentheses',
      'Create groups and control precedence',
      'Make patterns case-insensitive',
      'Escape special characters',
    ],
    correctAnswer: 1,
    explanation:
      'Parentheses create groups and control operator precedence, allowing you to apply operators to entire subpatterns.',
  },
  {
    id: 'q27',
    question: 'What does "(cat|dog) food" match?',
    choices: [
      'Either "cat" or "dog food"',
      'Either "cat food" or "dog food"',
      'Only "cat dog food"',
      'The literal text "(cat|dog) food"',
    ],
    correctAnswer: 1,
    explanation:
      'Grouping with parentheses makes the alternation apply to just "cat|dog", then "food" is matched after either alternative.',
  },
  {
    id: 'q28',
    question: 'How is "abc|def" different from "(abc|def)"?',
    choices: [
      'No difference in matching behavior',
      'The second creates a capturing group',
      'The first is faster',
      'The second requires escaping',
    ],
    correctAnswer: 1,
    explanation:
      'Both match the same text, but (abc|def) creates a capturing group that can be referenced later.',
  },
  {
    id: 'q29',
    question: 'What does "(red|blue|green) car" match?',
    choices: [
      'Only "red blue green car"',
      'Any of: "red car", "blue car", "green car"',
      'Cars of any color',
      'Only "red car"',
    ],
    correctAnswer: 1,
    explanation:
      'The grouped alternation matches any of the three color options followed by " car".',
  },
  {
    id: 'q30',
    question: 'In "gr(a|e)y", what does the group contain?',
    choices: ['The entire pattern', 'Just "a|e"', 'Just "gr"', 'Just "y"'],
    correctAnswer: 1,
    explanation:
      'The parentheses group contains just the alternation "a|e", allowing either letter in that position.',
  },
  {
    id: 'q31',
    question: 'What does "(https?)://" match?',
    choices: [
      'Either "http://" or "https://"',
      'Only "https://"',
      'Only "http://"',
      'Multiple protocols together',
    ],
    correctAnswer: 0,
    explanation:
      'The group contains "https?" which matches "http" or "https", making it match either protocol followed by "://".',
  },
  {
    id: 'q32',
    question: 'How do you match literal parentheses in regex?',
    choices: ['Use () directly', 'Use \\( and \\)', 'Use [()]', 'Both B and C'],
    correctAnswer: 3,
    explanation: 'Both \\( \\) (escaped) and [()] (in character class) match literal parentheses.',
  },
  {
    id: 'q33',
    question: 'What is the difference between "colou?r" and "(colou)?r"?',
    choices: [
      'No difference',
      'First makes "u" optional, second makes "colou" optional',
      'Second is invalid syntax',
      'First is case-sensitive, second is not',
    ],
    correctAnswer: 1,
    explanation:
      'colou?r makes just the "u" optional, while (colou)?r makes the entire "colou" optional.',
  },
  {
    id: 'q34',
    question: 'In "(Mr|Mrs|Ms)\\.? Smith", what does the pattern match?',
    choices: [
      'Only names with periods',
      'Only names without periods',
      'Names with or without a period after the title',
      'Multiple people named Smith',
    ],
    correctAnswer: 2,
    explanation:
      'The \\. is escaped to match a literal period, and ? makes it optional, so it matches titles with or without a period.',
  },
  {
    id: 'q35',
    question: 'What does "(ab)+" match?',
    choices: [
      'One or more "a" followed by one or more "b"',
      'One or more repetitions of "ab"',
      'Either "a" or "b" one or more times',
      'The literal text "(ab)+"',
    ],
    correctAnswer: 1,
    explanation:
      'The + quantifier applies to the entire group (ab), matching "ab", "abab", "ababab", etc.',
  },
  {
    id: 'q36',
    question: 'Which pattern matches phone numbers like "(555) 123-4567" or "555-123-4567"?',
    choices: [
      '(\\d{3}) \\d{3}-\\d{4}|\\d{3}-\\d{3}-\\d{4}',
      '\\(?\\d{3}\\)?[-\\s]\\d{3}-\\d{4}',
      '(\\d{3}|\\(\\d{3}\\)) \\d{3}-\\d{4}',
      'All of the above',
    ],
    correctAnswer: 1,
    explanation:
      '\\(?\\d{3}\\)?[-\\s]\\d{3}-\\d{4} elegantly handles optional parentheses and flexible separators.',
  },
  {
    id: 'q37',
    question: 'What does "((red|blue)|green)" match?',
    choices: [
      'Only nested colors',
      'Any of: red, blue, or green',
      'Multiple colors together',
      'Invalid pattern',
    ],
    correctAnswer: 1,
    explanation:
      'Nested groups still match any of the three colors, but create multiple capture groups.',
  },
  {
    id: 'q38',
    question: 'In "(cat|dog){2}", what gets repeated?',
    choices: [
      'The last character only',
      'The entire alternation group',
      'Just "cat" twice or "dog" twice',
      'Invalid syntax',
    ],
    correctAnswer: 1,
    explanation:
      'The {2} quantifier applies to the entire group, so it matches patterns like "catcat", "dogdog", "catdog", "dogcat".',
  },
  {
    id: 'q39',
    question: 'What does "file\\.(txt|pdf|doc)" match?',
    choices: [
      'Only files with all three extensions',
      'Files with any one of the three extensions',
      'The literal text "file.(txt|pdf|doc)"',
      'Only .txt files',
    ],
    correctAnswer: 1,
    explanation:
      'This matches filenames ending with .txt, .pdf, or .doc (the dot is escaped to be literal).',
  },
  {
    id: 'q40',
    question: 'How do nested groups work in "(a(b|c)d)"?',
    choices: [
      'Only the outer group is captured',
      'Both outer and inner groups are captured',
      'Only the inner group is captured',
      'Nested groups are not allowed',
    ],
    correctAnswer: 1,
    explanation:
      'Nested groups create multiple capture groups - the outer group captures the whole match, the inner group captures just the alternation.',
  },
  {
    id: 'q41',
    question: 'What does "(\\w+)@(\\w+)" capture in "user@domain"?',
    choices: [
      'The entire email address',
      'Two groups: "user" and "domain"',
      'Only the @ symbol',
      'Nothing is captured',
    ],
    correctAnswer: 1,
    explanation:
      'Two capturing groups are created: the first captures "user", the second captures "domain".',
  },
  {
    id: 'q42',
    question: 'In "(very )+good", what does this match?',
    choices: [
      'Only "very good"',
      'Only "very very good"',
      'One or more "very " followed by "good"',
      'The word "very" and "good" separately',
    ],
    correctAnswer: 2,
    explanation:
      'The + applies to the group "very ", so it matches "very good", "very very good", "very very very good", etc.',
  },
  {
    id: 'q43',
    question: 'What is the precedence order in regex?',
    choices: [
      'Alternation, quantifiers, concatenation',
      'Quantifiers, concatenation, alternation',
      'Concatenation, alternation, quantifiers',
      'All have equal precedence',
    ],
    correctAnswer: 1,
    explanation:
      'Precedence from highest to lowest: quantifiers, concatenation, alternation. Use parentheses to override.',
  },
  {
    id: 'q44',
    question: 'What does "(red|green) and (blue|yellow)" match?',
    choices: [
      'Only specific color combinations',
      'Any combination of the colors with " and " between',
      'All four colors together',
      'Only "red and blue"',
    ],
    correctAnswer: 1,
    explanation:
      'This matches any combination: "red and blue", "red and yellow", "green and blue", "green and yellow".',
  },
  {
    id: 'q45',
    question: 'How do you make a group non-capturing?',
    choices: ['Use (?:pattern)', 'Use [pattern]', 'Use {pattern}', 'Use \\(pattern\\)'],
    correctAnswer: 0,
    explanation:
      '(?:pattern) creates a non-capturing group that provides grouping without creating a capture group.',
  },
  {
    id: 'q46',
    question: 'What does "a(bc)+d" match?',
    choices: [
      'Only "abcd"',
      'a followed by one or more "bc" followed by d',
      'a, bc, and d separately',
      'Invalid pattern',
    ],
    correctAnswer: 1,
    explanation:
      'This matches "abcd", "abcbcd", "abcbcbcd", etc. - the group "bc" is repeated one or more times.',
  },
  {
    id: 'q47',
    question: 'In "((a|b)(c|d))", how many groups are created?',
    choices: ['One group', 'Two groups', 'Three groups', 'Four groups'],
    correctAnswer: 2,
    explanation:
      'Three groups are created: the outer group ((a|b)(c|d)), and two inner groups (a|b) and (c|d).',
  },
  {
    id: 'q48',
    question: 'What does "(ha)+" match in "hahaha"?',
    choices: [
      'Only the first "ha"',
      'The entire string "hahaha"',
      'Each "ha" separately',
      'Only "haha"',
    ],
    correctAnswer: 1,
    explanation:
      'The + quantifier applies to the group (ha), so it matches the entire string "hahaha" as one match.',
  },
  {
    id: 'q49',
    question: 'Which is correct for matching "Mr. Smith" or "Dr. Jones"?',
    choices: [
      '(Mr|Dr)\\. (Smith|Jones)',
      'Mr\\.|Dr\\. Smith|Jones',
      '(Mr\\.|Dr\\.) (Smith|Jones)',
      'Both A and C',
    ],
    correctAnswer: 3,
    explanation:
      'Both patterns work correctly by grouping the titles and names separately with proper escaping of the period.',
  },
  {
    id: 'q50',
    question: 'What happens with ungrouped alternation in "cat|dog food"?',
    choices: [
      'Matches "cat food" or "dog food"',
      'Matches "cat" or "dog food"',
      'Invalid syntax',
      'Matches any food',
    ],
    correctAnswer: 1,
    explanation:
      'Without grouping, alternation has low precedence, so it matches "cat" OR "dog food", not the intended pattern.',
  },

  // Complex Pattern Building (25 questions)
  {
    id: 'q51',
    question: 'Which pattern matches valid email addresses like "user@domain.com"?',
    choices: [
      '\\w+@\\w+\\.\\w+',
      '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}',
      '.*@.*\\..*',
      'All of the above',
    ],
    correctAnswer: 1,
    explanation:
      'The second pattern is most comprehensive, handling valid email characters and requiring proper domain structure.',
  },
  {
    id: 'q52',
    question: 'What pattern matches phone numbers in formats "123-456-7890" and "(123) 456-7890"?',
    choices: [
      '\\d{3}-\\d{3}-\\d{4}|(\\d{3}) \\d{3}-\\d{4}',
      '\\(?\\d{3}\\)?[-\\s]\\d{3}-\\d{4}',
      '(\\d{3}|\\(\\d{3}\\))[-\\s]\\d{3}-\\d{4}',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All three patterns can match both phone number formats, though some are more elegant than others.',
  },
  {
    id: 'q53',
    question:
      'Which pattern validates passwords requiring uppercase, lowercase, digit, and 8+ characters?',
    choices: [
      '[A-Za-z0-9]{8,}',
      '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}',
      '[A-Z][a-z]\\d{8,}',
      '\\w{8,}',
    ],
    correctAnswer: 1,
    explanation:
      'The second pattern uses positive lookaheads to ensure all requirements are met without specifying order.',
  },
  {
    id: 'q54',
    question: 'What pattern matches URLs starting with "http://" or "https://"?',
    choices: ['https?://.*', '(http|https)://\\S+', 'https?://[^\\s]+', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All patterns match URLs with both protocols, though they handle the rest of the URL slightly differently.',
  },
  {
    id: 'q55',
    question: 'Which pattern matches dates in MM/DD/YYYY format?',
    choices: [
      '\\d{2}/\\d{2}/\\d{4}',
      '(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}',
      '[0-1][0-9]/[0-3][0-9]/[12][09]\\d{2}',
      'All are valid approaches',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match the format, with varying levels of validation for valid month/day/year ranges.',
  },
  {
    id: 'q56',
    question: 'What pattern matches IPv4 addresses like "192.168.1.1"?',
    choices: [
      '\\d+\\.\\d+\\.\\d+\\.\\d+',
      '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}',
      '(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)',
      'All match the format with different validation levels',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match IPv4 format, with the third providing proper validation for 0-255 range.',
  },
  {
    id: 'q57',
    question: 'Which pattern matches HTML tags like "<div>" and "</div>"?',
    choices: ['<[^>]+>', '</?\\w+>', '</?[a-zA-Z][a-zA-Z0-9]*\\s*[^>]*>', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All patterns match HTML tags with different levels of precision and handling of attributes.',
  },
  {
    id: 'q58',
    question:
      'What pattern matches credit card numbers with optional separators (1234-5678-9012-3456)?',
    choices: [
      '\\d{4}-?\\d{4}-?\\d{4}-?\\d{4}',
      '\\d{4}[\\s-]?\\d{4}[\\s-]?\\d{4}[\\s-]?\\d{4}',
      '(\\d{4}[\\s-]?){3}\\d{4}',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns handle 16-digit credit card numbers with optional hyphens or spaces as separators.',
  },
  {
    id: 'q59',
    question: 'Which pattern matches file paths on both Windows and Unix systems?',
    choices: [
      '[A-Za-z]:\\\\.*|/.*',
      '([A-Za-z]:\\\\|\\\\/)[^<>:"|?*\\n\\r]*',
      '([A-Za-z]:|\\\\)?[/\\\\][^/\\\\:*?"<>|\\n\\r]*([/\\\\][^/\\\\:*?"<>|\\n\\r]*)*',
      'All approaches are valid',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns attempt to match different path formats, though cross-platform path matching is inherently complex.',
  },
  {
    id: 'q60',
    question: 'What pattern matches MAC addresses like "00:1B:44:11:3A:B7"?',
    choices: [
      '([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}',
      '([0-9A-F]{2}:){5}[0-9A-F]{2}',
      '[0-9A-Fa-f]{2}:[0-9A-Fa-f]{2}:[0-9A-Fa-f]{2}:[0-9A-Fa-f]{2}:[0-9A-Fa-f]{2}:[0-9A-Fa-f]{2}',
      'All match the format',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match MAC address format, with the first being most concise using repetition.',
  },
  {
    id: 'q61',
    question: 'Which pattern validates US Social Security Numbers (XXX-XX-XXXX)?',
    choices: [
      '\\d{3}-\\d{2}-\\d{4}',
      '[0-9]{3}-[0-9]{2}-[0-9]{4}',
      '\\b\\d{3}-\\d{2}-\\d{4}\\b',
      'All are equivalent',
    ],
    correctAnswer: 3,
    explanation:
      '\\d and [0-9] are equivalent, and the word boundaries in the third option ensure complete number matching.',
  },
  {
    id: 'q62',
    question: 'What pattern matches time in 24-hour format (HH:MM)?',
    choices: [
      '\\d{2}:\\d{2}',
      '([01]?[0-9]|2[0-3]):[0-5][0-9]',
      '(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]',
      'All match the format',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match time format, with later ones providing better validation for valid hour/minute ranges.',
  },
  {
    id: 'q63',
    question: 'Which pattern matches hashtags like "#regex" or "#Python3"?',
    choices: ['#\\w+', '#[a-zA-Z0-9_]+', '#[a-zA-Z][a-zA-Z0-9_]*', 'All match hashtag format'],
    correctAnswer: 3,
    explanation:
      'All patterns match hashtags, with \\w+ being most concise and the third ensuring it starts with a letter.',
  },
  {
    id: 'q64',
    question: 'What pattern matches currency amounts like "$123.45" or "$1,234.56"?',
    choices: [
      '\\$\\d+\\.\\d{2}',
      '\\$\\d{1,3}(,\\d{3})*\\.\\d{2}',
      '\\$[0-9,]+\\.[0-9]{2}',
      'Pattern B is most accurate',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B correctly handles comma separators for thousands and ensures proper decimal format.',
  },
  {
    id: 'q65',
    question: 'Which pattern matches hexadecimal color codes like "#FF5733"?',
    choices: [
      '#[0-9A-Fa-f]{6}',
      '#[0-9A-F]{6}',
      '#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})',
      'All match hex colors',
    ],
    correctAnswer: 2,
    explanation: 'Pattern C matches both 3-digit (#F73) and 6-digit (#FF7733) hex color formats.',
  },
  {
    id: 'q66',
    question: 'What pattern validates strong passwords (8+ chars, upper, lower, digit, special)?',
    choices: [
      '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}',
      '[A-Za-z0-9@$!%*?&]{8,}',
      '\\w{8,}[@$!%*?&]+',
      'Pattern A is most comprehensive',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern A uses lookaheads to ensure all character types are present without requiring specific order.',
  },
  {
    id: 'q67',
    question: 'Which pattern matches ISBN-10 numbers like "0-123-45678-9"?',
    choices: [
      '\\d-\\d{3}-\\d{5}-\\d',
      '[0-9]-[0-9]{3}-[0-9]{5}-[0-9Xx]',
      '\\d{1}-\\d{3}-\\d{5}-[\\dXx]',
      'All match ISBN-10 format',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match ISBN-10 format, with later ones correctly allowing X/x as the check digit.',
  },
  {
    id: 'q68',
    question: 'What pattern matches domain names like "example.com" or "sub.example.org"?',
    choices: [
      '[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}',
      '([a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\\.))+[a-zA-Z]{2,}',
      '\\w+\\.\\w+',
      'Pattern B is most accurate',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B follows RFC specifications for domain names with proper length and character restrictions.',
  },
  {
    id: 'q69',
    question: 'Which pattern matches license plates like "ABC-1234" or "12A-B3C4"?',
    choices: [
      '[A-Z]{3}-\\d{4}|\\d{2}[A-Z]-[A-Z]\\d[A-Z]\\d',
      '[A-Z0-9]{3}-[A-Z0-9]{4}',
      '[A-Z]{3}-[0-9]{4}|[0-9]{2}[A-Z]-[A-Z][0-9][A-Z][0-9]',
      'All match different plate formats',
    ],
    correctAnswer: 3,
    explanation:
      'Different patterns match different license plate formats - the choice depends on specific regional requirements.',
  },
  {
    id: 'q70',
    question: 'What pattern matches version numbers like "1.2.3" or "10.15.7"?',
    choices: [
      '\\d+\\.\\d+\\.\\d+',
      '(\\d+\\.)+(\\d+)',
      '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}',
      'All match version format',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match semantic version numbers, though they may handle edge cases differently.',
  },
  {
    id: 'q71',
    question: 'Which pattern matches scientific notation like "1.23e-4" or "5.67E+10"?',
    choices: [
      '\\d+\\.\\d+[eE][+-]?\\d+',
      '[0-9]+\\.[0-9]+[eE][+\\-][0-9]+',
      '\\d+(\\.\\d+)?[eE][+-]?\\d+',
      'Pattern C is most flexible',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles both integer and decimal mantissas with optional decimal part and flexible exponent signs.',
  },
  {
    id: 'q72',
    question:
      'What pattern matches SQL table names (letters, digits, underscores, start with letter)?',
    choices: [
      '[a-zA-Z]\\w*',
      '[a-zA-Z][a-zA-Z0-9_]*',
      '[A-Za-z_][A-Za-z0-9_]*',
      'Patterns A and B are equivalent',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B are equivalent since \\w includes [a-zA-Z0-9_]. Pattern C also allows starting with underscore.',
  },
  {
    id: 'q73',
    question: 'Which pattern matches coordinate pairs like "(40.7128, -74.0060)"?',
    choices: [
      '\\(\\d+\\.\\d+, -?\\d+\\.\\d+\\)',
      '\\([+-]?\\d+\\.\\d+, [+-]?\\d+\\.\\d+\\)',
      '\\([+-]?\\d{1,3}\\.\\d{4}, [+-]?\\d{1,3}\\.\\d{4}\\)',
      'Pattern B is most general',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B handles both positive and negative coordinates with flexible decimal precision.',
  },
  {
    id: 'q74',
    question: 'What pattern matches JSON strings with escaped quotes like "Hello "World""?',
    choices: ['"[^"]*"', '"([^"\\\\]|\\\\.)*"', '".*?"', 'Pattern B handles escapes correctly'],
    correctAnswer: 3,
    explanation:
      'Pattern B correctly handles escaped characters including escaped quotes within JSON strings.',
  },
  {
    id: 'q75',
    question: 'Which pattern matches valid variable names in most programming languages?',
    choices: [
      '[a-zA-Z_]\\w*',
      '[a-zA-Z_][a-zA-Z0-9_]*',
      '[A-Za-z_$][A-Za-z0-9_$]*',
      'All are valid for different languages',
    ],
    correctAnswer: 3,
    explanation:
      "Different languages have different rules - some allow $ in identifiers (JavaScript), others don't (Python).",
  },

  // Advanced Applications (25 questions)
  {
    id: 'q76',
    question: 'How do you validate that a string contains only alternating vowels and consonants?',
    choices: [
      '^([aeiou][bcdfghjklmnpqrstvwxyz])*[aeiou]?$',
      '^[aeiou]([bcdfghjklmnpqrstvwxyz][aeiou])*$',
      '^([aeiou][bcdfghjklmnpqrstvwxyz]|[bcdfghjklmnpqrstvwxyz][aeiou])*$',
      'All approaches work for different starting patterns',
    ],
    correctAnswer: 3,
    explanation:
      'Different patterns handle different starting conditions (vowel-first vs consonant-first vs either).',
  },
  {
    id: 'q77',
    question: 'What pattern matches palindromes of exactly 5 characters?',
    choices: [
      '(.)(.){backref2}{backref1}',
      '(.)(.).{backref2}{backref1}',
      '^(.)(.).{backref2}{backref1}$',
      'Pattern C with anchors is correct',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C uses backreferences with anchors to ensure the entire string is a 5-character palindrome.',
  },
  {
    id: 'q78',
    question: 'How do you match words that appear exactly twice in a text?',
    choices: [
      'Use backreferences with lookaheads',
      'Not possible with regex alone',
      'Use named groups and repetition',
      'Requires multiple regex passes',
    ],
    correctAnswer: 1,
    explanation:
      'Counting occurrences across an entire text requires stateful processing beyond regex capabilities.',
  },
  {
    id: 'q79',
    question: 'What pattern validates balanced parentheses like "(())" but not "(()"?',
    choices: [
      '\\([^)]*\\)',
      'Cannot be done with regular regex',
      '(\\([^()]*\\))*',
      'Requires recursive regex or parsing',
    ],
    correctAnswer: 3,
    explanation:
      'True balanced parentheses matching requires recursion or a parsing algorithm, not regular expressions.',
  },
  {
    id: 'q80',
    question: 'How do you match lines that don\'t contain the word "error"?',
    choices: ['^(?!.*error).*$', '^[^error]*$', '^((?!error).)*$', 'Both A and C work'],
    correctAnswer: 3,
    explanation:
      'Both patterns use negative lookahead to ensure "error" doesn\'t appear anywhere in the line.',
  },
  {
    id: 'q81',
    question: 'What pattern matches words that start and end with the same letter?',
    choices: [
      '(\\w)\\w*\\1',
      '^(\\w)\\w*\\1$',
      '\\b(\\w)\\w*\\1\\b',
      'Pattern C with word boundaries is best',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C uses word boundaries to match complete words and backreferences for same start/end letters.',
  },
  {
    id: 'q82',
    question: 'How do you validate passwords with at least 2 digits but no more than 4?',
    choices: [
      '(?=(.*\\d){2,4})^(?!.*(\\d.*){5,}).*$',
      '(?=(.*\\d.*){2})(?!(.*\\d.*){5}).*',
      'Complex pattern with multiple lookaheads',
      'Better handled by counting after matching',
    ],
    correctAnswer: 3,
    explanation:
      "While possible with complex lookaheads, it's often cleaner to match digits and count them programmatically.",
  },
  {
    id: 'q83',
    question: 'What pattern matches words with exactly 3 vowels?',
    choices: [
      '\\b(?=(\\w*[aeiou]){3}\\w*)(?!(\\w*[aeiou]){4}\\w*)\\w+\\b',
      '\\b[bcdfghjklmnpqrstvwxyz]*[aeiou][bcdfghjklmnpqrstvwxyz]*[aeiou][bcdfghjklmnpqrstvwxyz]*[aeiou][bcdfghjklmnpqrstvwxyz]*\\b',
      'Both approaches are overly complex',
      'Better to count vowels programmatically',
    ],
    correctAnswer: 3,
    explanation:
      'While technically possible, such complex patterns are better handled by matching words and counting vowels in code.',
  },
  {
    id: 'q84',
    question: 'How do you match strings where every "a" is followed by "b"?',
    choices: [
      '^(?!.*a(?!b))[ab]*$',
      '^(b*ab)*b*$',
      '^[^a]*a?b[^a]*$',
      'Pattern A uses negative lookahead correctly',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern A uses negative lookahead to ensure no "a" exists that isn\'t followed by "b".',
  },
  {
    id: 'q85',
    question: 'What pattern matches HTML comments <!-- comment -->?',
    choices: ['<!--.*-->', '<!--.*?-->', '<!--[^>]*-->', 'Pattern B is non-greedy and correct'],
    correctAnswer: 3,
    explanation:
      'Pattern B uses non-greedy matching to stop at the first closing tag, avoiding issues with multiple comments.',
  },
  {
    id: 'q86',
    question: 'How do you match quoted strings that can contain escaped quotes?',
    choices: [
      '"[^"]*"',
      '"([^"\\\\]|\\\\.)*"',
      '"(\\\\.|[^"\\\\])*"',
      'Patterns B and C handle escapes correctly',
    ],
    correctAnswer: 3,
    explanation:
      'Both patterns B and C handle escaped characters within quoted strings, including escaped quotes.',
  },
  {
    id: 'q87',
    question: 'What pattern validates IPv6 addresses?',
    choices: [
      '([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}',
      'Extremely complex due to compression rules',
      '([0-9a-fA-F]{0,4}:){0,7}[0-9a-fA-F]{0,4}',
      'Better to use specialized libraries',
    ],
    correctAnswer: 3,
    explanation:
      'IPv6 has complex compression and formatting rules that make regex validation very difficult and error-prone.',
  },
  {
    id: 'q88',
    question: 'How do you match nested tags like <div><span>text</span></div>?',
    choices: [
      '<div>.*</div>',
      '<div>.*?</div>',
      'Cannot handle arbitrary nesting with regex',
      'Requires recursive patterns',
    ],
    correctAnswer: 2,
    explanation:
      'Regular expressions cannot handle arbitrary nesting levels - this requires a proper parser or recursive patterns.',
  },
  {
    id: 'q89',
    question: 'What pattern matches valid mathematical expressions like "2+3*4"?',
    choices: [
      '[0-9+\\-*/()\\s]+',
      'Too complex for regex alone',
      '\\d+([+\\-*/]\\d+)*',
      'Requires expression parser',
    ],
    correctAnswer: 3,
    explanation:
      'Mathematical expressions have precedence rules and parentheses that require proper parsing, not just regex.',
  },
  {
    id: 'q90',
    question: 'How do you validate that opening and closing XML tags match?',
    choices: [
      '<(\\w+)>.*</\\1>',
      '<([^>]+)>.*</\\1>',
      'Cannot handle nested same-name tags',
      'Requires XML parser',
    ],
    correctAnswer: 2,
    explanation:
      'While backreferences can match simple cases, nested tags of the same name require a proper XML parser.',
  },
  {
    id: 'q91',
    question: 'What pattern matches words that contain all five vowels?',
    choices: [
      '(?=.*a)(?=.*e)(?=.*i)(?=.*o)(?=.*u)\\w+',
      '\\b(?=.*a)(?=.*e)(?=.*i)(?=.*o)(?=.*u)\\w+\\b',
      'Both patterns work',
      'Better to check programmatically',
    ],
    correctAnswer: 2,
    explanation:
      'Both patterns use lookaheads to ensure all five vowels are present, with pattern B using word boundaries.',
  },
  {
    id: 'q92',
    question: 'How do you match CSS selectors like "#id", ".class", "element"?',
    choices: ['[#.]?\\w+', '(#\\w+|.\\w+|\\w+)', '[#.]\\w+|\\w+', 'All match basic selectors'],
    correctAnswer: 3,
    explanation:
      'All patterns match basic CSS selectors, though they handle edge cases differently.',
  },
  {
    id: 'q93',
    question: 'What pattern validates JSON object keys (quoted strings)?',
    choices: [
      '"[^"]*"',
      '"([^"\\\\]|\\\\.)*"',
      '"(\\\\.|[^"\\\\])*"',
      'Patterns B and C handle escapes',
    ],
    correctAnswer: 3,
    explanation: 'Patterns B and C properly handle escaped characters within JSON string keys.',
  },
  {
    id: 'q94',
    question: 'How do you match function calls like "func(arg1, arg2)"?',
    choices: [
      '\\w+\\([^)]*\\)',
      '\\w+\\(([^(),]*(,[^(),]*)*)\\)',
      'Complex due to nested calls',
      'Depends on language syntax',
    ],
    correctAnswer: 2,
    explanation:
      'Nested function calls and complex arguments make this challenging for regex alone.',
  },
  {
    id: 'q95',
    question: 'What pattern matches strings with equal numbers of opening and closing brackets?',
    choices: [
      '\\[[^\\]]*\\]',
      'Cannot be done with regular regex',
      'Requires counting algorithm',
      'Needs context-free grammar',
    ],
    correctAnswer: 1,
    explanation:
      'Counting and balancing brackets requires context-free parsing capabilities beyond regular expressions.',
  },
  {
    id: 'q96',
    question: 'How do you validate SQL identifiers (table/column names)?',
    choices: [
      '[a-zA-Z_]\\w*',
      '[a-zA-Z_][a-zA-Z0-9_]*',
      '"`?[a-zA-Z_][a-zA-Z0-9_]*`?',
      'Depends on SQL dialect',
    ],
    correctAnswer: 3,
    explanation:
      'Different SQL databases have different rules for identifiers, including quoted identifiers and keywords.',
  },
  {
    id: 'q97',
    question: 'What pattern matches cron expressions like "0 12 * * MON"?',
    choices: [
      '[0-9*,/\\-]+ [0-9*,/\\-]+ [0-9*,/\\-]+ [0-9*,/\\-]+ [0-9A-Z*,/\\-]+',
      'Too complex for simple regex',
      'Requires field validation',
      'Better to parse each field separately',
    ],
    correctAnswer: 3,
    explanation:
      'Cron expressions have complex field-specific validation rules that are better handled by specialized parsers.',
  },
  {
    id: 'q98',
    question: 'How do you match regex patterns themselves (meta-regex)?',
    choices: [
      'Extremely complex escaping required',
      'Need to escape all metacharacters',
      'Context-dependent interpretation',
      'Better to treat as literal strings',
    ],
    correctAnswer: 3,
    explanation:
      'Regex patterns as data are best treated as literal strings and parsed by regex engines rather than matched by regex.',
  },
  {
    id: 'q99',
    question: 'What pattern validates international phone numbers?',
    choices: [
      '\\+?[1-9]\\d{1,14}',
      '\\+[1-9]\\d{1,3}[\\s\\-]?\\d{1,14}',
      'Extremely complex due to format variations',
      'Use specialized phone number libraries',
    ],
    correctAnswer: 3,
    explanation:
      'International phone numbers have complex country-specific formatting rules best handled by specialized libraries.',
  },
  {
    id: 'q100',
    question: 'How do you match patterns that span multiple lines with complex structure?',
    choices: [
      'Use DOTALL flag with careful pattern design',
      'Split into multiple single-line patterns',
      'Use parsing libraries for complex structures',
      'All approaches have their use cases',
    ],
    correctAnswer: 3,
    explanation:
      'Choice depends on complexity - simple multiline patterns can use DOTALL, complex structures need parsers.',
  },
];
